// extracted by mini-css-extract-plugin
module.exports = {"videoTop":"styles_videoTop__2C5cv","videoExtra":"styles_videoExtra__1Ssjh","scissionPage":"styles_scissionPage__1_PxW"};